module.exports = require("sanitize-html");


//////////////////
// WEBPACK FOOTER
// external "sanitize-html"
// module id = 601
// module chunks = 0